import React from 'react';

export const TooltipDetailRow = ({
  paramName,
  value,
}: {
  paramName: string;
  value: string | string[] | number | null | undefined | boolean | [];
}) => {
  const formattedValue =
    value && typeof value === 'object'
      ? value.join(', ')
      : typeof value === 'boolean'
      ? value
        ? 'yes'
        : 'no'
      : value || '-';
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <strong style={{ marginRight: 40 }}>{paramName}:</strong>{' '}
      <span
        style={{
          maxWidth: 160,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {formattedValue}
      </span>
    </div>
  );
};
